import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function GoogleTagManager() {
  const { data } = useSelector(state => state.store);

  useEffect(() => {
    // Aguarda o carregamento dos dados da empresa
    if (!data?.empresa) return;

    const gtmId = data.empresa.google_tag_manager_id;
    const gaId = data.empresa.google_analytics_id;

    // Carrega Google Tag Manager se configurado
    if (gtmId) {
      loadGTM(gtmId);
      addGTMNoScript(gtmId);
    }

    // Carrega Google Analytics se configurado (alternativa ao GTM)
    if (gaId && !gtmId) {
      loadGoogleAnalytics(gaId);
    }
  }, [data]);

  const loadGTM = (gtmId) => {
    // Verifica se já foi carregado
    if (window.dataLayer && window.dataLayer.find(item => item['gtm.start'])) {
      return;
    }

    // Script do Google Tag Manager no HEAD
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', gtmId);

    console.log(`[GTM] Carregado com ID: ${gtmId}`);
  };

  const addGTMNoScript = (gtmId) => {
    // Verifica se o noscript já existe
    const existingNoScript = document.querySelector(`noscript[data-gtm="${gtmId}"]`);
    if (existingNoScript) return;

    // Adiciona noscript no início do body
    const noscript = document.createElement('noscript');
    noscript.setAttribute('data-gtm', gtmId);
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    // Insere no início do body
    if (document.body.firstChild) {
      document.body.insertBefore(noscript, document.body.firstChild);
    } else {
      document.body.appendChild(noscript);
    }
  };

  const loadGoogleAnalytics = (gaId) => {
    // Verifica se já foi carregado
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaId}"]`)) {
      return;
    }

    // Carrega script do Google Analytics
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);

    // Inicializa o gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', gaId);

    // Expõe gtag globalmente
    window.gtag = gtag;

    console.log(`[GA] Carregado com ID: ${gaId}`);
  };

  return null;
}
